import React from 'react';
import { useTranslation } from '../../../localization/useTranslation';
import { ClipboardCopy } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';

const ClipboardCopyComponent = ({ model, value }) => {
  const T = useTranslation();
  return (
    <>
      <ClipboardCopy hoverTip={T.common.copy} isReadOnly={model.disabled} >
        { value ?? '' }
      </ClipboardCopy>
    </>
  );
};

ClipboardCopyComponent.propTypes = ComponentPropTypes;

export default React.memo(ClipboardCopyComponent);
